module.exports = __webpack_public_path__ + "e446fcc8894eb0b847b0251ef3f79ce0.svg";